var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 531.229,
    height: 419.485,
    viewBox: "0 0 531.229 419.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acorn",
    "data-name": "Group 1047",
    transform: "translate(-4793.43 -15188.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M351.87,209.69c4.977,19.289,10.578,38.578,16.18,57.867,9.957-3.109,19.91-5.6,29.867-8.711C402.894,234.58,406,211.557,406,189.78c-18.043,6.844-36.09,13.066-54.133,19.91Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M374.89,135.02c-13.688-3.734-28-5.6-41.688-4.355,1.246,7.465,3.109,14.934,4.977,21.777,11.82-5.6,24.266-11.2,36.711-17.422Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M387.33,139.38c-15.555,8.09-31.109,15.555-47.289,23.023,3.109,13.066,6.223,25.512,9.332,38.578,18.668-6.844,37.957-13.688,56.621-21.156-.621-11.82-1.867-23.023-4.355-32.977a62.477,62.477,0,0,0-14.309-7.469Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M370.54,276.89c3.734,11.2,6.844,23.023,10.578,34.223.621,0,1.246-.621,1.867-.621,4.355-13.688,8.711-27.379,11.82-40.445-8.09,1.863-16.18,4.352-24.266,6.844Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M328.84,156.8c-1.867-8.09-3.734-16.8-5.6-24.891-14.312,1.867-28,6.844-41.066,13.066,1.867,9.957,3.734,19.91,5.6,29.246,14.312-5.6,28-11.2,41.066-17.422Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M289.64,184.18c2.488,12.445,5.6,24.891,8.09,37.957,11.82-5.6,23.023-10.578,34.844-14.934,2.488-.621,4.977-1.867,7.465-2.488-3.109-12.445-6.223-24.891-9.332-37.957-13.066,5.6-26.754,11.82-41.066,17.422Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M327.6,219.02c-9.332,3.734-18.043,7.465-27.379,11.82,4.355,17.422,8.711,35.465,13.066,52.891,4.977-1.246,9.957-3.109,14.312-4.355,10.578-3.109,20.535-6.223,30.488-8.711-5.6-18.668-11.2-37.957-16.18-57.246-4.355,1.867-9.332,3.734-14.309,5.6Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M322,290.58c-1.867.621-3.734,1.246-6.223,1.867,3.734,13.688,6.844,26.754,10.578,40.445a172.934,172.934,0,0,0,16.18-6.223c9.957-3.734,19.91-8.09,29.867-12.445q-5.6-17.73-11.2-35.465c-13.07,4.352-26.137,8.086-39.2,11.82Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M353.11,332.89q-12.135,4.664-24.266,9.332c3.734,14.312,8.09,28.621,11.82,42.934,4.977-1.867,9.957-3.734,14.312-5.6,8.09-16.8,14.934-33.6,21.777-51.023-.621-1.246-.621-3.109-1.246-4.355-7.465,2.492-14.93,5.6-22.4,8.715Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M213.73,211.55c-5.6,7.465-10.578,14.312-15.555,17.422,3.734,11.2,6.223,22.4,8.711,33.6,13.688-4.355,27.379-10.578,40.445-16.18-4.355-13.688-9.332-27.379-14.934-40.445a106.636,106.636,0,0,0-18.668,5.6Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M208.75,271.29c2.488,13.066,4.977,26.754,7.465,39.82q22.4-4.664,44.8-11.2c-3.109-15.555-6.844-30.488-11.2-45.422q-20.532,9.334-41.066,16.8Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M217.46,320.45c2.488,15.555,4.355,30.488,6.844,46.043,15.555-4.977,31.734-9.957,47.289-14.934-3.109-14.312-5.6-28.621-8.711-42.312-14.93,3.734-30.488,8.09-45.422,11.2Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M273.46,360.27c-16.18,4.977-31.734,9.957-47.91,14.934q.932,6.533,1.867,13.066c1.867,13.688,4.355,26.754,7.465,40.445,17.422-4.977,33.6-12.445,49.777-19.91-3.109-13.066-6.223-26.754-9.332-39.82-.621-3.113-1.242-5.6-1.867-8.715Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M236.75,438.04c1.867,8.09,3.734,15.555,5.6,23.645a111.432,111.432,0,0,0,19.91,8.09c13.066,3.734,25.512,0,36.711-8.09q-6.533-21.468-11.2-42.934c-17.422,7.469-33.6,14.934-51.023,19.289Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M173.91,325.42c1.246,18.668,3.734,36.711,9.332,54.133,10.578-3.734,21.777-6.844,32.355-10.578-2.488-15.555-4.355-31.734-6.844-47.289a349.161,349.161,0,0,1-34.844,3.734Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M177.02,270.04c6.844-1.246,13.688-3.109,20.535-4.977a319.05,319.05,0,0,0-9.332-34.844c-21.156-4.355-46.668-47.91-53.512-68.445-8.715-30.488,3.73-60.977-6.227-85.242-19.289,3.109-29.867,28.621-44.8,41.688,11.2,61.6,42.312,112,93.336,151.82Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M175.78,280a229.231,229.231,0,0,0-2.488,36.09,204.983,204.983,0,0,0,33.6-3.109c-1.867-13.066-4.355-26.133-6.844-38.578q-12.135,2.795-24.27,5.6Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M216.22,378.31c-10.578,3.109-20.535,6.844-30.488,9.957,5.6,16.8,13.688,32.355,24.266,45.422a116.24,116.24,0,0,0,15.555-2.488c-1.867-10.578-4.355-21.156-5.6-31.734-1.863-6.848-2.488-14.312-3.73-21.156Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M258.54,250.13q6.533,23.332,11.2,46.668c11.82-3.734,23.023-7.465,34.223-10.578C299.607,268.8,295.251,252,290.9,234.575c-10.578,4.977-21.156,10.578-32.355,15.555Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M279.07,177.96q-2.8-14-5.6-28a158.983,158.983,0,0,0-36.09,28.621c-1.867,1.867-3.109,3.734-4.977,5.6,1.867,3.109,3.109,6.223,4.977,9.332,13.691-4.977,28-9.957,41.691-15.555Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M241.11,202.22q8.4,19.6,14.934,39.2c11.2-4.977,22.4-10.578,33.6-16.18-3.109-12.445-5.6-25.512-8.09-38.578a358.6,358.6,0,0,1-40.445,15.559Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M271.6,306.13c3.109,14.312,5.6,28,8.711,42.312,12.445-3.734,24.891-8.09,37.332-12.445-3.734-13.688-7.465-27.379-11.2-40.445-11.824,3.113-23.023,6.844-34.844,10.578Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M282.18,357.78c0,.621,0,1.246.621,1.246,3.734,14.934,6.844,30.488,10.578,45.422,7.465-3.734,14.934-6.844,23.023-9.957,4.977-1.867,10.578-4.355,15.555-6.223-3.734-14.312-8.09-28.621-11.82-43.555-12.449,4.355-24.891,8.711-37.957,13.066Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M313.29,405.69c-6.223,2.488-11.82,5.6-18.043,8.09,3.109,13.688,6.844,27.379,10.578,41.066,12.445-11.2,23.023-27.379,31.734-42.934a135.414,135.414,0,0,0-4.355-14.934c-5.6,3.113-13.07,5.6-19.914,8.711Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M556.58,468.54c23.645-24.891,29.246-58.488,57.867-74.668.621-1.867.621-3.109,0-6.844a111.7,111.7,0,0,1-4.977-13.066c-8.711-25.512,0-65.332-9.332-93.957-24.891-76.535-103.29-80.266-181.07-107.64a514.791,514.791,0,0,1-24.891,146.22,502.294,502.294,0,0,1-67.82,136.89c-.621,1.867-1.867,3.109-2.488,4.977l6.844,1.867c78.4,21.777,167.38,59.109,224.62,8.09,0-.625.621-1.246,1.242-1.867Z",
    transform: "translate(4709.747 15111.836)",
    fill: "#00469a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcorn);
export default __webpack_public_path__ + "static/media/acorn.0120eb0609a808636009a59ecaaa4636.svg";
export { ForwardRef as ReactComponent };